import { OrderUrlConstant } from 'src/constants';
import {
  CancelOrderDto,
  CreateOrderDto,
  GetOrderDto,
  GetOrderListDto,
  GetOrderListResponseDto,
  OrderDetailsDto,
} from 'src/dtos';
import { WithAuthToken, replacePlaceholders, httpRequest } from 'src/utils';

export class OrderApi {
  async create({ params, body, authToken }: WithAuthToken<CreateOrderDto>): Promise<OrderDetailsDto> {
    const { accountId } = params;
    const url = replacePlaceholders(OrderUrlConstant.CREATE, { accountId });

    return httpRequest<OrderDetailsDto>({
      method: 'POST',
      url,
      body,
      authToken,
    });
  }

  async list({ params, queryParams, authToken }: WithAuthToken<GetOrderListDto>): Promise<GetOrderListResponseDto> {
    const { accountId } = params;

    const url = replacePlaceholders(OrderUrlConstant.LIST, { accountId });

    return httpRequest<GetOrderListResponseDto>({
      method: 'GET',
      url,
      authToken,
      queryParams,
    });
  }

  async retrieve({ params, authToken }: WithAuthToken<GetOrderDto>): Promise<OrderDetailsDto> {
    const { id, accountId } = params;

    const url = replacePlaceholders(OrderUrlConstant.RETRIEVE, { id, accountId });

    return httpRequest<OrderDetailsDto>({
      method: 'GET',
      url,
      authToken,
    });
  }

  async cancel({ params, authToken }: WithAuthToken<CancelOrderDto>): Promise<void> {
    const { accountId, id } = params;

    const url = replacePlaceholders(OrderUrlConstant.CANCEL, { id, accountId });

    return httpRequest<void>({
      method: 'PUT',
      url,
      authToken,
    });
  }
}
